import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ftlogo from "../../assets/images/ftlogo.png";
import { LuSearchSlash } from "react-icons/lu";
import {Link} from "react-router-dom"
const Topbar = () => {
  return (
    <div className="topbar">
      <div className="container">
       
          <Row>
            <Col className="tp-width">
              <div className="logo">
                <Link to={"/"}><img src={ftlogo} alt=""/></Link>
                
               
              </div>
            </Col>
            <Col className="tp-width" xs={6}>
              <div className="search">
              
              </div> 
            </Col>
            <Col className="tp-width">


              {/* 
              Dont Need for Login and Signup Button
              
              <div className="btns">

                <Button className="Blackbtn">
                  <a href="#">Register</a>
                </Button>
                <Button className="theme-btn">
                  <a href="#">Login</a> 
                </Button>
              </div> */}
            </Col>
          </Row>
       
      </div>
    </div>
  );
};

export default Topbar;
